import { z } from 'zod';

export const driverSchema = z.object({
  id: z.number().min(1),
  name: z.string().min(1),
  driverId: z.string().min(1),
  modifiedOn: z.string(),
});

export const driversSchema = z.array(driverSchema);

export type Driver = z.infer<typeof driverSchema>;
